import React from "react";
import "../styles/StartTestCard.scss";

const StartTestCard = ({ title, durationMinutes, totalQuestions, onStart }) => {
  return (
    <div className="start-test-overlay">
      <div className="start-test-card">
        <div className="start-test-card__header">
          <h2>{title}</h2>
          <p className="start-test-card__subtitle">
            Get ready to begin your assessment. Make sure you are in a quiet
            place with a stable internet connection.
          </p>
        </div>

        <div className="start-test-card__meta">
          <div className="meta-item">
            <span className="meta-label">Duration</span>
            <span className="meta-value">{durationMinutes} minutes</span>
          </div>
          <div className="meta-item">
            <span className="meta-label">Questions</span>
            <span className="meta-value">{totalQuestions}</span>
          </div>
          <div className="meta-item">
            <span className="meta-label">Mode</span>
            <span className="meta-value">Fullscreen required</span>
          </div>
        </div>

        <div className="test-instructions">
          <h3>Before you start</h3>
          <ul>
            <li>Once started, the timer will continue to run.</li>
            <li>Do not exit fullscreen or switch tabs during the test.</li>
            <li>Read each question carefully before answering.</li>
            <li>Click Start Test when you are ready.</li>
          </ul>
        </div>

        <button className="btn-start" onClick={onStart}>
          Start Test
        </button>
      </div>
    </div>
  );
};

export default StartTestCard;
